import { computed } from 'vue'

export function useDevice () {
  // https://stackoverflow.com/a/9039885
  const isIOS = computed(() => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  })

  const displayMode = computed(() => {
    if (document.referrer.startsWith('android-app://'))
      return 'twa'
    if (window.matchMedia('(display-mode: browser)').matches)
      return 'browser'
    if (window.matchMedia('(display-mode: standalone)').matches)
      return 'standalone'
    if (window.matchMedia('(display-mode: minimal-ui)').matches)
      return 'minimal-ui'
    if (window.matchMedia('(display-mode: fullscreen)').matches)
      return 'fullscreen'
    if (window.matchMedia('(display-mode: window-controls-overlay)').matches)
      return 'window-controls-overlay'

    return 'unknown'
  })

  const isStandalone = computed(() => {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone || document.referrer.includes('android-app://')
  })

  return {
    isIOS,
    displayMode,
    isStandalone,
  }
}
